import type { ButtonBackground, ButtonColor, ButtonSize, ButtonStyle } from '@tranquility-ai/theme-components/button';

/**
 * Shared chrome for media-player icon triggers (play/pause, mute, settings,
 * rotate, zoom, fullscreen, transcript exports). Uses Serenity icon-on-inverse
 * hover — do not layer legacy `hover:bg-white/10` / `hover:bg-gray-*` on top.
 */
export const mediaIconButtonProps = {
  iconOnly: true,
  size: 'sm' as ButtonSize,
  style: 'text' as ButtonStyle,
  color: 'light' as ButtonColor,
  background: 'inverse' as ButtonBackground,
};
